// 동적으로 들어갈 tailwind css class를 정의하는 파일



export const ICON_FILL: any = {
    'neutral-black': 'text-neutral-black',
    'neutral-white': 'text-neutral-white',
    'gray2': 'text-gray2',
    'gray5': 'text-gray5',
    'gray10': 'text-gray10',
    'gray15': 'text-gray15',
    'gray20': 'text-gray20',
    'gray30': 'text-gray30',
    'gray40': 'text-gray40',
    'gray50': 'text-gray50',
    'gray60': 'text-gray60',
    'gray70': 'text-gray70',
    'gray80': 'text-gray80',
    'gray90': 'text-gray90',

    'grayOpacity5': 'text-grayOpacity5',
    'grayOpacity10': 'text-grayOpacity10',
    'grayOpacity20': 'text-grayOpacity20',
    'grayOpacity30': 'text-grayOpacity30',
    'grayOpacity40': 'text-grayOpacity40',
    'grayOpacity50': 'text-grayOpacity50',
    'grayOpacity60': 'text-grayOpacity60',
    'grayOpacity70': 'text-grayOpacity70',
    'grayOpacity80': 'text-grayOpacity80',
    'grayOpacity90': 'text-grayOpacity90',

    'blue5': 'text-blue5',
    'blue10': 'text-blue10',
    'blue20': 'text-blue20',
    'blue30': 'text-blue30',
    'blue40': 'text-blue40',
    'blue50': 'text-blue50',
    'blue60': 'text-blue60',
    'blue70': 'text-blue70',
    'blue80': 'text-blue80',
    'blue90': 'text-blue90',

    'red5': 'text-red5',
    'red10': 'text-red10',
    'red20': 'text-red20',
    'red30': 'text-red30',
    'red40': 'text-red40',
    'red50': 'text-red50',
    'red60': 'text-red60',
    'red70': 'text-red70',
    'red80': 'text-red80',
    'red90': 'text-red90',

    'green5': 'text-green5',
    'green10': 'text-green10',
    'green20': 'text-green20',
    'green30': 'text-green30',
    'green40': 'text-green40',
    'green50': 'text-green50',
    'green60': 'text-green60',
    'green70': 'text-green70',
    'green80': 'text-green80',
    'green90': 'text-green90',

    'orange5': 'text-orange5',
    'orange10': 'text-orange10',
    'orange20': 'text-orange20',
    'orange30': 'text-orange30',
    'orange40': 'text-orange40',
    'orange50': 'text-orange50',
    'orange60': 'text-orange60',
    'orange70': 'text-orange70',


    'risk-green': 'text-risk-green',
    'risk-yellow': 'text-risk-yellow',
    'risk-orange': 'text-isk-orange',
    'risk-red': 'text-risk-red',

    'risk-bg-green': 'text-risk-bg-green',
    'risk-bg-yellow': 'text-risk-bg-yellow',
    'risk-bg-orange': 'text-risk-bg-orange',
    'risk-bg-red': 'text-risk-bg-red',

    '1': 'text-1',
    '2': 'text-2',
    '3': 'text-3',
    '4': 'text-4',
}

type TailwindCSSKeys =
    | 'blue-rgba'
    | 'gray-rgba'
    | 'light-gray-rgba'
    | 'mapBg'
    | 'chart1'
    | 'chart2'
    | 'chart3'
    | 'chart4'
    | 'chart5'
    | 'chart6'
    | 'chart7'
    | 'chart8'
    | 'chart9'
    | 'chart10'
    | 'neutral-black'
    | 'neutral-white'
    | 'white'
    | 'black'
    | 'gray2'
    | 'gray5'
    | 'gray10'
    | 'gray15'
    | 'gray20'
    | 'gray30'
    | 'gray40'
    | 'gray50'
    | 'gray60'
    | 'gray70'
    | 'gray80'
    | 'gray90'
    | 'grayOpacity10'
    | 'grayOpacity20'
    | 'grayOpacity30'
    | 'grayOpacity40'
    | 'grayOpacity50'
    | 'grayOpacity60'
    | 'grayOpacity70'
    | 'grayOpacity80'
    | 'grayOpacity90'
    | 'grayOpacity5'
    | 'blue5'
    | 'blue10'
    | 'blue20'
    | 'blue30'
    | 'blue40'
    | 'blue50'
    | 'blue60'
    | 'blue70'
    | 'blue80'
    | 'blue90'
    | 'red5'
    | 'red10'
    | 'red20'
    | 'red30'
    | 'red40'
    | 'red50'
    | 'red60'
    | 'red70'
    | 'red80'
    | 'red90'
    | 'green5'
    | 'green10'
    | 'green20'
    | 'green30'
    | 'green40'
    | 'green50'
    | 'green60'
    | 'green70'
    | 'green80'
    | 'green90'
    | 'orange5'
    | 'orange10'
    | 'orange20'
    | 'orange30'
    | 'orange40'
    | 'orange50'
    | 'orange60'
    | 'orange70'
    | 'orange80'
    | 'orange90'
    | 'risk-green'
    | 'risk-yellow'
    | 'risk-orange'
    | 'risk-red'
    | 'risk-bg-green'
    | 'risk-bg-yellow'
    | 'risk-bg-orange'
    | 'risk-bg-red'
    | '1'
    | '2'
    | '3'
    | '4'
    | 'screen'
    | 'bg'
    | 'graybg'
    | 'hairline'
    | 'B1'
    | 'background'
    | 'layeredBackground'
    | 'floatBackground'
    | 'hairlineBorder'
    | 'grayBackground'
    | 'backgroundLevelB01'
    | 'backgroundLevel01'
    | 'backgroundLevel02'
    | 'backgroundLevel03'
    | 'backgroundLevel04'
    ;


export const TAILWIND_TO_CSS: Record<TailwindCSSKeys, string> = {
    "blue-rgba": "rgba(1, 152, 255, 0.05)",
    "gray-rgba": "rgba(17, 17, 17, 0.5);",
    "light-gray-rgba": "rgba(0, 0, 0, 0.2)",
    "mapBg": "#AFD5F0",
    "chart1": "#3366E6",
    "chart2": "#FF6633",
    "chart3": "#FF33FF",
    "chart4": "#FFFF99",
    "chart5": "#00B3E6",
    "chart6": "#E6B333",
    "chart7": "#FFB399",
    "chart8": "#999966",
    "chart9": "#99FF99",
    "chart10": "#B34D4D",
    'neutral-black': '#000',
    'neutral-white': '#FFF',
    'white': '#ffffff',
    'black': '#000000',
    'gray2': '#f9fafb',
    'gray5': '#f6f7f8',
    'gray10': '#f2f4f6',
    'gray15': '#edeff1',
    'gray20': '#e5e8eb',
    'gray30': '#d1d6db',
    'gray40': '#b0b8c1',
    'gray50': '#8b95a1',
    'gray60': '#6b7684',
    'gray70': '#4e5968',
    'gray80': '#333d4b',
    'gray90': '#191f28',

    'grayOpacity10': 'rgb(2 32 71 / 0.05)',
    'grayOpacity20': 'rgb(0 27 55 / 0.1)',
    'grayOpacity30': 'rgb(0 29 58 / 0.18)',
    'grayOpacity40': 'rgb(0 25 54 / 0.31)',
    'grayOpacity5': 'rgb(0 23 51 / 0.02)',
    'grayOpacity50': 'rgb(3 24 50 / 0.46)',
    'grayOpacity60': 'rgb(0 19 43 / 0.58)',
    'grayOpacity70': 'rgb(3 18 40 / 0.7)',
    'grayOpacity80': 'rgb(0 12 30 / 0.8)',
    'grayOpacity90': 'rgb(2 9 19 / 0.91)',

    'blue5': '#e8f3ff',
    'blue10': '#c9e2ff',
    'blue20': '#90c2ff',
    'blue30': '#64a8ff',
    'blue40': '#4593fc',
    'blue50': '#3182f6',
    'blue60': '#2272eb',
    'blue70': '#1b64da',
    'blue80': '#1957c2',
    'blue90': '#194aa6',

    'red5': '#ffeeee',
    'red10': '#ffd4d6',
    'red20': '#feafb4',
    'red30': '#fb8890',
    'red40': '#f66570',
    'red50': '#f66570',
    'red60': '#e42939',
    'red70': '#d22030',
    'red80': '#bc1b2a',
    'red90': '#a51926',

    'green5': '#f0faf6',
    'green10': '#aeefd5',
    'green20': '#76e4b8',
    'green30': '#3fd599',
    'green40': '#15c47e',
    'green50': '#03b26c',
    'green60': '#02a262',
    'green70': '#029359',
    'green80': '#028450',
    'green90': '#027648',

    'orange5': '#fff3e0',
    'orange10': '#ffe0b0',
    'orange20': '#ffcd80',
    'orange30': '#ffbd51',
    'orange40': '#ffa927',
    'orange50': '#fe9800',
    'orange60': '#fb8800',
    'orange70': '#f57800',
    'orange80': '#ed6700',
    'orange90': '#e45600',
    '1': '#ffffff',
    '2': '#ffffff',
    '3': '#ffffff',
    '4': '#ffffff',
    'screen': '#F6F7F8',
    'bg': '#FFFFFF',
    'graybg': '#F2F4F6',
    'hairline': '#E5E8EB',
    'B1': '#F2F4F6',


    'risk-green': '#34BB7A',
    'risk-yellow': '#F99F01',
    'risk-orange': '#FF4D00',
    'risk-red': '#DF1525',

    'risk-bg-green': '#E6F5F0',
    'risk-bg-yellow': '#FEF5E6',
    'risk-bg-orange': '#FFE4D9',
    'risk-bg-red': '#FFECEF',

    'background': '#ffffff',
    'layeredBackground': '#ffffff',
    'floatBackground': '#ffffff',
    'hairlineBorder': '#e5e8eb',
    'grayBackground': '#f2f4f6',
    'backgroundLevelB01': '#f2f4f6',
    'backgroundLevel01': '#ffffff',
    'backgroundLevel02': '#ffffff',
    'backgroundLevel03': '#ffffff',
    'backgroundLevel04': '#ffffff',

}

export const TAILWIND_TO_CSS_DARK: Record<TailwindCSSKeys, string> = {
    "blue-rgba": "rgba(1, 152, 255, 0.05)",
    "gray-rgba": "rgba(17, 17, 17, 0.5);",
    "light-gray-rgba": "rgba(0, 0, 0, 0.2)",
    "mapBg": "#AFD5F0",
    "chart1": "#3366E6",
    "chart2": "#FF6633",
    "chart3": "#FF33FF",
    "chart4": "#FFFF99",
    "chart5": "#00B3E6",
    "chart6": "#E6B333",
    "chart7": "#FFB399",
    "chart8": "#999966",
    "chart9": "#99FF99",
    "chart10": "#B34D4D",
    'neutral-black': '#000',
    'neutral-white': '#FFF',
    'white': '#000000',
    'black': '#ffffff',
    'gray2': '#101013',
    'gray5': '#202027',
    'gray10': '#2c2c35',
    'gray15': '#34343e',
    'gray20': '#3c3c47',
    'gray30': '#4d4d59',
    'gray40': '#62626d',
    'gray50': '#7e7e87',
    'gray60': '#9e9ea4',
    'gray70': '#c3c3c6',
    'gray80': '#e4e4e5',
    'gray90': '#ffffff',

    'blue5': '#202c4d',
    'blue10': '#23386a',
    'blue20': '#25478c',
    'blue30': '#265ab3',
    'blue40': '#2970d9',
    'blue50': '#3485fa',
    'blue60': '#449bff',
    'blue70': '#61b0ff',
    'blue80': '#8fcdff',
    'blue90': '#c8e7ff',

    'red5': '#3c2020',
    'red10': '#562025',
    'red20': '#7a242d',
    'red30': '#9e2733',
    'red40': '#ca2f3d',
    'red50': '#f04251',
    'red60': '#fa616d',
    'red70': '#fe818b',
    'red80': '#ffa8ad',
    'red90': '#ffa8ad',

    'green5': '#153729',
    'green10': '#135338',
    'green20': '#136d47',
    'green30': '#138a59',
    'green40': '#13a065',
    'green50': '#16bb76',
    'green60': '#26cf88',
    'green70': '#4ee4a6',
    'green80': '#82f6c5',
    'green90': '#ccffea',

    'orange5': '#3d2500',
    'orange10': '#563200',
    'orange20': '#804600',
    'orange30': '#a85f00',
    'orange40': '#cf7200',
    'orange50': '#f18600',
    'orange60': '#fd9528',
    'orange70': '#ffa861',
    'orange80': '#ffc39e',
    'orange90': '#ffe4d6',

    '1': '#202027',
    '2': '#2C2C35',
    '3': '#2C2C35',
    '4': '#4D4D59',

    'screen': '#101013',
    'bg': '#17171C',
    'graybg': '#101013',
    'hairline': '#3C3C47',
    'B1': '#101013',

    'risk-green': '#34BB7A',
    'risk-yellow': '#F99F01',
    'risk-orange': '#FF4D00',
    'risk-red': '#DF1525',

    'risk-bg-green': '#E6F5F0',
    'risk-bg-yellow': '#FEF5E6',
    'risk-bg-orange': '#FFE4D9',
    'risk-bg-red': '#FFECEF',

    'background': '#17171c',
    'layeredBackground': '#202027',
    'floatBackground': '#2c2c35',
    'hairlineBorder': '#3c3c47',
    'grayBackground': '#101013',
    'backgroundLevelB01': '#101013',
    'backgroundLevel01': '#202027',
    'backgroundLevel02': '#2c2c35',
    'backgroundLevel03': '#3c3c47',
    'backgroundLevel04': '#4d4d59',

    'grayOpacity5': 'rgb(209 209 253 / 0.05)',
    'grayOpacity10': 'rgb(217 217 255 / 0.11)',
    'grayOpacity20': 'rgb(222 222 255 / 0.19)',
    'grayOpacity30': 'rgb(224 224 255 / 0.27)',
    'grayOpacity40': 'rgb(232 232 253 / 0.36)',
    'grayOpacity50': 'rgb(242 242 255 / 0.47)',
    'grayOpacity60': 'rgb(248 248 255 / 0.6)',
    'grayOpacity70': 'rgb(253 253 255 / 0.75)',
    'grayOpacity80': 'rgb(253 253 254 / 0.89)',
    'grayOpacity90': 'rgb(255 255 255)',
}

export const DONUT_CHART_PALETTE: any = [
    "#EE4453",
    "#1C63D6",
    "#0AAF6D",
    "#F08FFB",
    "#FF9F2B",
    "#AF9C0A",
    "#488FB5",
    "#908FFB",
    "#702FFB",
    "#000000",
];
